import { render, staticRenderFns } from "./SmsCommentBubble.vue?vue&type=template&id=2b1b8ee0&scoped=true&"
import script from "./SmsCommentBubble.vue?vue&type=script&lang=ts&"
export * from "./SmsCommentBubble.vue?vue&type=script&lang=ts&"
import style0 from "./SmsCommentBubble.vue?vue&type=style&index=0&id=2b1b8ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b8ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VHover,VIcon,VRow,VTooltip})
